import { createAuthHeader } from '../utils/createAuthHeader';
import request from '../utils/httpRequest';

export const login = async ({ username, password, device, os, browser }) => {
    try {
        const res = await request.post('auth/login', { username, password, device, os, browser });

        return res.data;
    } catch (err) {
        if (!err.response) {
            return { status: 'NETWORK_ERROR', message: err.message };
        } else {
            return err.response.data;
        }
    }
};

export const googleLogin = async ({ token, device, os, browser }) => {
    try {
        const res = await request.post('auth/google', { token, device, os, browser });

        return res.data;
    } catch (err) {
        console.log(err);
        return err.response.data;
    }
};

export const register = async ({ email, password, fullName }) => {
    try {
        const res = await request.post('auth/register', { email, password, fullName });

        return res.data;
    } catch (err) {
        if (!err.response) {
            return { status: 'NETWORK_ERROR', message: err.message };
        } else {
            return err.response?.data;
        }
    }
};

export const verifyToken = async ({ uuidUser, activationCode }) => {
    try {
        const res = await request.post('auth/verify-code', { uuidUser: uuidUser, activationCode: activationCode });
        return res.data;
    } catch (err) {
        if (!err.response) {
            return { status: 'NETWORK_ERROR', message: err.message };
        } else {
            return err.response;
        }
    }
};

export const forgotPassword = async (email) => {
    try {
        const res = await request.post(
            'auth/forgot-password',
            {},
            {
                params: { email: email },
            },
        );

        return res.data;
    } catch (err) {
        if (!err.response) {
            return { status: 'NETWORK_ERROR', message: err.message };
        } else {
            return err.response;
        }
    }
};

export const resetPassword = async (formData) => {
    try {
        const res = await request.post('auth/reset-password', formData);

        return res.data;
    } catch (err) {
        if (!err.response) {
            return { status: 'NETWORK_ERROR', message: err.message };
        } else {
            return err.response?.data;
        }
    }
};

export const changePassword = async (formData) => {
    try {
        const headers = await createAuthHeader();
        const res = await request.post('auth/change-password', formData, { headers });
        return res.data;
    } catch (err) {
        if (!err.response) {
            return { status: 'NETWORK_ERROR', message: err.message };
        } else {
            console.log('err.response.data', err.response.data);
            return err.response?.data;
        }
    }
};

export const logout = async (formData) => {
    try {
        // const headers = await createAuthHeader();
        const res = await request.post('auth/logout', formData);
        return res.data;
    } catch (err) {
        if (!err.response) {
            return { status: 'NETWORK_ERROR', message: err.message };
        } else {
            console.log('err.response.data', err.response.data);
            return err.response.data;
        }
    }
};

export const logoutSession = async (formData) => {
    try {
        const headers = await createAuthHeader();
        const res = await request.post('auth/logout-session', {}, { params: formData, headers });
        return res.data;
    } catch (err) {
        if (!err.response) {
            return { status: 'NETWORK_ERROR', message: err.message };
        } else {
            console.log('err.response.data', err.response.data);
            return err.response.data;
        }
    }
};
